import { TextButton } from 'seagull';
import { AttachFile } from 'seagull/icons';
import { DEFAULT_MAX_TOTAL_SIZE, MAX_FILE_SIZE, useAttachFiles } from "../../hooks/useAttachFiles";
import styles from "./AttachFiles.module.scss";
import { AttachFilesTestIds } from "./AttachFiles.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const AttachFiles = _ref => {
  let {
    onFilesUploaded,
    maxTotalSize = DEFAULT_MAX_TOTAL_SIZE,
    maxFileSize = MAX_FILE_SIZE,
    initialAttachments = []
  } = _ref;
  const {
    attachments,
    openFilePicker,
    isUploading
  } = useAttachFiles({
    onFilesUploaded,
    maxTotalSize,
    maxFileSize,
    initialAttachments
  });
  const currentTotalSize = attachments.reduce((sum, file) => sum + file.size, 0);
  const isDisabled = currentTotalSize >= maxTotalSize || isUploading;
  const maxTotalSizeMB = maxTotalSize / (1024 * 1024);
  const tooltipTitle = "You've exceeded the ".concat(maxTotalSizeMB, "MB upload limit. Remove files to continue.");
  return /*#__PURE__*/_jsx(TextButton, {
    className: styles.button,
    "data-testid": AttachFilesTestIds.Button(),
    underline: "none",
    onClick: openFilePicker,
    prefixIcon: /*#__PURE__*/_jsx(AttachFile, {}),
    disabled: isDisabled,
    tooltip: isDisabled ? {
      title: tooltipTitle,
      'data-testid': AttachFilesTestIds.ButtonTooltip()
    } : undefined,
    children: 'Attach Files'
  });
};
export default AttachFiles;